import { XFlatLoader } from '@adornis/chemistry/elements/components/x-flat-loader.js';
import { customElement } from 'lit/decorators.js';
/**
 * @customElement board-component-flat-loader
 */
@customElement('board-component-flat-loader')
export class BoardComponentFlatLoader extends XFlatLoader {
  override styles() {
    return [
      ...super.styles(),
      {
        '@keyframes slide': { '0%': { backgroundPosition: '-500px 0' }, '100%': { backgroundPosition: '468px 0' } },
        display: 'block',
        flexShrink: '0',
        height: '1em',
        borderRadius: '1em',
        background: `linear-gradient(to right, ${this.colors.white} 8%, ${this.colors.primary} 38%, ${this.colors.white} 54%)`,
        backgroundSize: '1000px 640px',
        animation: 'slide 1.5s cubic-bezier(0.3, 0.1, 0.3, 0.85) infinite',
      },
    ];
  }
}
